import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { offerStack, PRICE } from '../../data/salesContent';
export function OfferSection() {
  return <section id="oferta" className="bg-ink px-5 pb-20 md:pb-28" data-id="element-115" data-mp="fhd6a0vt9r5m">
      <div className="mx-auto max-w-3xl rounded-3xl border-2 border-gold bg-ink-soft p-6 md:p-12" data-id="element-116" data-mp="fjzabqjhtoj3">
        <h2 className="text-center font-display text-3xl font-black uppercase leading-tight text-cream md:text-4xl" data-id="element-117" data-mp="akwackide8hz">
          Todo lo que recibís por <span className="text-gold" data-id="element-118" data-mp="1q81kkdl68of">{PRICE}</span>
        </h2>
        <ul className="mt-10 divide-y divide-ink-line" data-id="element-119" data-mp="1on68sjg6lpi">
          {offerStack.map(item => <li key={item.tag} className="flex items-start gap-4 py-4" data-id="element-120" data-mp="3sug7xj6i0s4p">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold text-black" data-id="element-121" data-mp="3nz98ink9i9ll">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-122" data-mp="3j0fxd1sg6uol" />
              </span>
              <p className="text-lg md:text-xl" data-id="element-123" data-mp="1as0m80ktheyw">
                <span className="font-display font-extrabold uppercase text-gold" data-id="element-124" data-mp="1ar8qmpr7zh8m">{item.tag}</span>{' '}
                <span className="text-cream" data-id="element-125" data-mp="1fjil8j3a55h8">{item.name}</span>
              </p>
            </li>)}
        </ul>
        <div className="my-10 flex items-center gap-4" aria-hidden="true" data-id="element-126" data-mp="10vnrczdjcv2k">
          <span className="h-px flex-1 bg-gold/40" data-id="element-127" data-mp="15tpdxua67cis" />
          <span className="h-2 w-2 rotate-45 bg-gold" data-id="element-128" data-mp="1tirs2s5lin8j" />
          <span className="h-px flex-1 bg-gold/40" data-id="element-129" data-mp="1tj1j8j2dn0ft" />
        </div>
        <div className="text-center" data-id="element-130" data-mp="1yhv08lgvh9kq">
          <p className="text-base font-bold uppercase tracking-[0.2em] text-neutral-400 md:text-lg" data-id="element-131" data-mp="1ygtla5wqk2xq">Precio final</p>
          <p className="mt-1 font-display text-5xl font-black text-gold md:text-6xl" data-id="element-132" data-mp="1kk6d16zc1qci">{PRICE}</p>
          <p className="mt-3 text-base text-neutral-300 md:text-lg" data-id="element-133" data-mp="1oli3feq16flr">Pago único · Acceso digital inmediato</p>
        </div>
        <div className="mt-8" data-id="element-134" data-mp="d40azbdwh2ej">
          <CtaButton note="Acceso al sistema completo después de la compra." data-id="element-135" data-mp="d5bcf4jvhy2h">Quiero dejar de preparar todo desde cero</CtaButton>
        </div>
      </div>
    </section>;
}